import BannerRouter from './BannerRouter';
export default BannerRouter;
